/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { IDelayedExecutionManager_$type } from "./IDelayedExecutionManager";
/**
 * @hidden
 */
var DataGridDelayedExecutionManager = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DataGridDelayedExecutionManager, _super);
    function DataGridDelayedExecutionManager(a) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.a = a;
        return _this;
    }
    DataGridDelayedExecutionManager.prototype.cancelPending = function (a) {
        this.a.clearTimeout(a);
    };
    DataGridDelayedExecutionManager.prototype.executeIn = function (a, b) {
        return this.a.setTimeout(function () { return a(); }, b);
    };
    DataGridDelayedExecutionManager.$t = markType(DataGridDelayedExecutionManager, 'DataGridDelayedExecutionManager', Base.$, [IDelayedExecutionManager_$type]);
    return DataGridDelayedExecutionManager;
}(Base));
export { DataGridDelayedExecutionManager };
//# sourceMappingURL=DataGridDelayedExecutionManager.js.map
